import { render, staticRenderFns } from "./BaseLikeButton.vue?vue&type=template&id=f067d07e&scoped=true&"
import script from "./BaseLikeButton.vue?vue&type=script&lang=js&"
export * from "./BaseLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseLikeButton.vue?vue&type=style&index=0&id=f067d07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f067d07e",
  null
  
)

export default component.exports